import React from "react";

const SVGSort = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.5 10L8 12.5L10.5 10M5.5 6L8 3.5L10.5 6"
        stroke="#4E4B48"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SVGSort;
